import React from "react";
import { CssBaseline, Typography, Box, FormControl, FormLabel, TextField, FormControlLabel, Button, Link, Checkbox } from "@mui/material";
import { Card, SignInContainer } from "./styled";
import { Image } from "../../components/design-system";
import logo from '../../assets/img/logo.png';
import { sx } from "./sx";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth.hook";

const LoginPage: React.FC = () => {

    const { login } = useAuth()

    const { css } = sx();
    const navigate = useNavigate();

    const [emailError, setEmailError] = React.useState(false);
    const [emailErrorMessage, setEmailErrorMessage] = React.useState('');
    const [passwordError, setPasswordError] = React.useState(false);
    const [passwordErrorMessage, setPasswordErrorMessage] = React.useState('');
    /*const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };*/
    
    const handleSubmit = async (username: string, password: string) => {
        const response = await login(username, password);
        
        if(response.status === 201) {
            navigate('/inicio');
        } else if (response.status === 401) {
            setEmailError(true);
            setPasswordError(true);
            setEmailErrorMessage('Invalid credentials');
        }
    };
    
    const validateInputs = (event: any) => {
        event.preventDefault();
        const username = document.getElementById('email') as HTMLFormElement;
        const password = document.getElementById('password') as HTMLFormElement;
        
        let isValid = true;
        
        if (!username.value) {
            setEmailError(true);
            setEmailErrorMessage('Username is required.');
            isValid = false;
        } else {
            setEmailError(false);
            setEmailErrorMessage('');
        }

        if (!password.value || password.value.length < 6) {
            setPasswordError(true);
            setPasswordErrorMessage('Password must be at least 6 characters long.');
            isValid = false;
        } else {
            setPasswordError(false);
            setPasswordErrorMessage('');
        }

        if (isValid) {
            handleSubmit(username.value, password.value);
        }

        //return isValid;
    };

    return (
        <CssBaseline>
            <SignInContainer style={css.page} direction="column" justifyContent="space-between">
                <Card variant="outlined">
                    <Image
                        src={logo}
                        alt='Mariana Ramos Advocacia'
                        objectFit='contain'
                        maxHeight={60}
                    />
                    <Typography
                        component="h1"
                        variant="h4"
                        sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
                    >
                        Entrar
                    </Typography>
                    <Box
                        component="form"
                        onSubmit={validateInputs}
                        noValidate
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            gap: 2,
                        }}
                    >
                        <FormControl>
                        <FormLabel htmlFor="email">Usuário</FormLabel>
                        <TextField
                            error={emailError}
                            helperText={emailErrorMessage}
                            id="email"
                            type="email"
                            name="email"
                            placeholder="Seu usuário"
                            autoComplete="email"
                            autoFocus
                            required
                            fullWidth
                            variant="outlined"
                            color={emailError ? 'error' : 'primary'}
                        />
                        </FormControl>
                        <FormControl>
                        <FormLabel htmlFor="password">Senha</FormLabel>
                        <TextField
                            error={passwordError}
                            helperText={passwordErrorMessage}
                            name="password"
                            placeholder="••••••"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            autoFocus
                            required
                            fullWidth
                            variant="outlined"
                            color={passwordError ? 'error' : 'primary'}
                        />
                        </FormControl>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            style={css.submitButton}
                        >
                            Entrar
                        </Button>
                        {/* <Link
                            component="button"
                            type="button"
                            onClick={handleClickOpen}
                            variant="body2"
                            sx={{ alignSelf: 'center' }}
                        >
                            Esqueceu sua senha?
                        </Link> */}
                    </Box>
                </Card>
            </SignInContainer>
        </CssBaseline>
    )
}

export { LoginPage }